import BaseAssignmentView from "./base_assignment_view";

export default function getView() {
  return BaseAssignmentView;
}
